export const applyCustomTheme = (customTheme = {}, partnerId = null) => {
  if (!customTheme || Object.keys(customTheme).length === 0) {
    return;
  }

  const root = document.documentElement;

  Object.entries(customTheme).forEach(([key, value]) => {
    if (value && typeof value === 'string') {
      root.style.setProperty(`--${key}`, value);
    }
  });

  if (partnerId) {
    root.setAttribute('data-custom-theme', partnerId);
  }
};

export const removeCustomTheme = () => {
  const root = document.documentElement;
  root.removeAttribute('data-custom-theme');
};

export const applyCustomLayout = layoutClass => {
  if (!layoutClass) return;

  const root = document.documentElement;
  root.classList.add(`layout-${layoutClass}`);
};

export const removeCustomLayout = layoutClass => {
  if (!layoutClass) return;

  const root = document.documentElement;
  root.classList.remove(`layout-${layoutClass}`);
};

export default {
  applyCustomTheme,
  removeCustomTheme,
  applyCustomLayout,
  removeCustomLayout,
};
